import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import PrivateRoute from "../../components/layout-components/PrivateRoute";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/home`}
          component={lazy(() => import(`./home`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/users`}
          component={lazy(() => import(`./usermanage`))}
        />

        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/branches`}
          component={lazy(() => import(`./masterdata/branchlist`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/cscs`}
          component={lazy(() => import(`./masterdata/depolist`))}
        />

        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/applications`}
          component={lazy(() => import(`./eapplication`))}
        />
        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/application/detail/:id`}
          component={lazy(() => import(`./eappdetails/index`))}
        />

        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/schedules`}
          component={lazy(() => import(`./schedules`))}
        />

        <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/complains`}
          component={lazy(() => import(`./complain/index`))}
        />

        {/* <PrivateRoute
          exact
          path={`${APP_PREFIX_PATH}/locked`}
          component={lazy(() => import(`./locked-account/index`))}
        /> */}
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
